import { ChangeEvent, useEffect, useState } from 'react';

import { withMask } from 'use-mask-input';

import { MasterNameApi } from '@/api';
import { Input } from '@/components/TailwindComponents';
import { IJMSFormFieldProps } from '@/pages/JMS/Managament/data/data';
import { useBookingStore } from '@/pages/JMS/store/BookingStore';

interface SSNInputProps {
  field: IJMSFormFieldProps;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  value: string;
}

export const SSNInput = ({
  field,
  value,
  onChange,
  disabled,
}: SSNInputProps) => {
  const { booking } = useBookingStore();

  const [ssn, setSSN] = useState<string>(value);

  useEffect(() => {
    const fetchSSN = async () => {
      try {
        const masterNameId = booking?.identity?._id;
        if (!masterNameId) return;

        const { data } = await MasterNameApi.getMasterNameSSN(masterNameId);
        setSSN(data.ssn);
      } catch (err) {
        throw new Error();
      }
    };

    fetchSSN();
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSSN(e.target.value);
    onChange(e);
  };

  const mask = '999-99-9999';

  return (
    <div className="flex flex-row gap-0.5 items-end">
      <div className="flex flex-col gap-0.5">
        <label
          htmlFor={field.name}
          className="text-sm font-medium text-gray-800"
        >
          {field.label}
        </label>
        <Input
          {...field}
          ref={withMask(mask, { autoUnmask: true })}
          value={ssn}
          onChange={handleChange}
          onBlur={handleChange}
          className="w-full"
          disabled={disabled}
        />
      </div>
    </div>
  );
};
